module.exports = __webpack_public_path__ + "static/palm-3fcb8015b9914da902b7f13d02235245.png";